// 1、根据ID获取产品信息
window.SimpleProductAPI = {
  // 根据ID获取产品
  async getProductById(productId) {
    try {
      // 先获取handle
      const handle = await this.getHandleById(productId);
      if (!handle) {
        throw new Error(`无法找到产品ID: ${productId}`);
      }
      
      // 再用handle获取完整信息
      return await this.getProductByHandle(handle);
    } catch (error) {
      console.error('根据ID获取产品失败:', error);
      return null;
    }
  },
  
  // 根据ID获取handle（保持原有方法不变）
  async getHandleById(productId) {
    try {
      const query = `
        query($id: ID!) {
          product(id: $id) {
            handle
          }
        }
      `;
      
      const response = await fetch('/api/2024-10/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': 'd722b24e0c1bd54665b4c58d0a19f20c'
        },
        body: JSON.stringify({ 
          query, 
          variables: { id: `gid://shopify/Product/${productId}` } 
        })
      });
      
      const data = await response.json();
      if (data.errors) {
        throw new Error(JSON.stringify(data.errors));
      }
      
      return data.data.product?.handle || null;
    } catch (error) {
      console.error('获取handle失败:', error);
      return null;
    }
  },
  
  // 根据handle获取产品（保持原有方法不变）
  async getProductByHandle(handle) {
    try {
      const response = await fetch(`/products/${handle}.js`);
      if (!response.ok) {
        throw new Error(`产品不存在: ${handle}`);
      }
      const text = await response.text();
      if (!text) {
        throw new Error('响应为空');
      }
      return JSON.parse(text);
    } catch (error) {
      console.error('获取产品失败:', error);
      return null;
    }
  },
  
  // 并发--根据多个ID获取多个产品
  async getProductsByIds(productIds) {
    console.log('开始并发获取产品:', productIds);
    
    // 使用Promise.all并发请求
    const promises = productIds.map(productId => this.getProductById(productId));
    const products = await Promise.all(promises);
    
    // 过滤掉null值（失败的产品）
    const successful = products.filter(product => product !== null);
    const failed = productIds.filter((id, index) => products[index] === null);
    
    console.log(`并发请求完成: 成功 ${successful.length} 个, 失败 ${failed.length} 个`);
    
    return {
      successful,
      failed,
      total: productIds.length
    };
  }
};

//获取所有在线产品
async function getAllProducts(options = {}) {
    const {
        limit = 200,
        page = 1,
        collection = 'all',
        sortBy = 'best-selling'
    } = options;
    
    try {
        const response = await fetch(`/collections/${collection}/products.json?limit=${limit}&page=${page}&sort_by=${sortBy}`);
        const data = await response.json();

        return  data.products
    } catch (error) {
        console.error('获取产品失败:', error);
        return [];
    }
}

// 根据产品ID获取产品完整信息（包含库存、评论）----单个获取
async function getCompleteProductInfoById(productId) {
  try {
       const query = `
      query($id: ID!) {
        product(id: $id) {
          id
          title
          handle
          description
          descriptionHtml
          vendor
          productType
          tags
          createdAt
          updatedAt
          availableForSale
          onlineStoreUrl

          #产品评论
          metafield(namespace: "reviews", key: "rating_count") {
            value
            type
          }

          # 价格信息
          priceRange {
            minVariantPrice {
              amount
              currencyCode
            }
            maxVariantPrice {
              amount
              currencyCode
            }
          }
          
          # 图片信息
          images(first: 10) {
            edges {
              node {
                id
                url
                altText
                width
                height
              }
            }
          }
          
          variants(first: 50) {
            edges {
              node {
                id
                title
                sku
                availableForSale
                quantityAvailable
                price {
                  amount
                  currencyCode
                }
                compareAtPrice {
                  amount
                  currencyCode
                }
                selectedOptions {
                  name
                  value
                }
                image {
                  id
                  url
                  altText
                  width
                  height
                }
                weight
                weightUnit
              }
            }
          }
          
          # 选项信息
          options {
            id
            name
            values
          }
          
          # SEO信息
          seo {
            title
            description
          }
        }
      }
    `;
    
    const response = await fetch('/api/2024-10/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': 'd722b24e0c1bd54665b4c58d0a19f20c'
      },
      body: JSON.stringify({
        query,
        variables: { 
          id: `gid://shopify/Product/${productId}`,
        }
      })
    });
    
    const data = await response.json();
    
    if (data.errors) {
      throw new Error(JSON.stringify(data.errors));
    }
    
    return data.data.product;
  } catch (error) {
    console.error('获取产品库存失败:', error);
    return null;
  }
}
// 并发获取多个产品完整信息-----多个并发获取
async function getMultipleProductsConcurrently(productIds) {
  const startTime = performance.now();
  
  try {
    // 创建并发请求
    const promises = productIds.map(async (productId) => {
      try {
        const product = await getCompleteProductInfoById(productId);
        return { success: true, product, productId };
      } catch (error) {
        return { success: false, error: error.message, productId };
      }
    });
    
    // 等待所有请求完成
    const results = await Promise.all(promises);
    
    const endTime = performance.now();
    const totalTime = ((endTime - startTime) / 1000).toFixed(2);
    
    // 分类结果
    const successful = results.filter(r => r.success).map(r => r.product);
    const failed = results.filter(r => !r.success).map(r => ({ 
      productId: r.productId, 
      error: r.error 
    }));
    
    return {
      successful,
      failed,
      total: productIds.length,
      time: totalTime
    };
    
  } catch (error) {
    console.error('并发请求异常:', error);
    return {
      successful: [],
      failed: productIds.map(id => ({ productId: id, error: error.message })),
      total: productIds.length,
      time: 0
    };
  }
}

// 使用示例
async function getKUCUN(){
  const productIds = ['8621796491499', '8788755185899', '8788756529387'];
  const product = await getMultipleProductsConcurrently(productIds);
  console.log('产品信息：',product)
}

// getKUCUN()
